export default __webpack_public_path__ + "locales/ru/Article.json?hash=618c28c7c2c1d0355ec3a25fbb7bbc5e";